import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _Config } from "@discovery/common-dplus/lib/state";
import { pipe } from "fp-ts/function";
import * as Option from "fp-ts/Option";
import { _Col2ColDataMeta, _Col2Id, _Col2TemplateId, _ColAttributes2Title, } from "@discovery/sonic-api-ng-optics";
import { Title, _ContentGridViewAll, BannerIdM, _MandatoryParams, } from "./optics";
import { useUser } from "../../utils/hooks/useUser";
import { useAds } from "../../utils/hooks/useAds";
import { RailTypes } from "../rails";
import { ExploreTemplateId } from "../explore";
const ExploreDetailView = React.lazy(() => import("./view"));
const getProps = (data) => {
    const titleM = Fold.preview(Fold.compose(_ColAttributes2Title, M._Just()), data);
    const title = M.fromMaybe(titleM, "");
    const mandatoryParamsM = Fold.view(_MandatoryParams, data);
    const mandatoryParams = pipe(mandatoryParamsM, Option.getOrElse(() => ""));
    const itemsPerPageM = Fold.preview(_Col2ColDataMeta, data);
    const itemsTotalPagesM = M.chain((x) => x.itemsTotalPages, itemsPerPageM);
    const itemsTotalPages = M.fromMaybe(itemsTotalPagesM, 0);
    const collectionIdM = Fold.preview(_Col2Id, data);
    const templateIdM = Fold.preview(_Col2TemplateId, data);
    const exploreDetails = Fold.toArray(_ContentGridViewAll, data);
    const length = exploreDetails.length;
    const exploreTitle = Fold.preview(Title, data);
    const bannerIdM = Fold.preview(BannerIdM, data);
    return {
        title,
        exploreDetails,
        exploreTitle,
        collectionIdM,
        itemsTotalPages,
        templateIdM,
        length,
        bannerIdM,
        mandatoryParams,
    };
};
const Explore = ({ title, exploreDetails, exploreTitle, collectionIdM, itemsTotalPages, length, templateIdM, bannerIdM, environment, mandatoryParams, }) => {
    const [configM] = useGlobalState(_Config);
    const { isAnonymous, premiumPackagesM } = useUser();
    const { adsHasValidPackage, enableAds } = useAds();
    //Config
    const premiumPackages = M.fromMaybe(premiumPackagesM, [""]);
    const parentalLockM = M.chain((x) => x.parentalLock, configM);
    const minimumAgeM = M.chain((x) => x.minimumAge, parentalLockM);
    const minimumAge = M.fromMaybe(minimumAgeM, 0);
    const bannerId = M.fromMaybe(bannerIdM, "");
    const isAdsEnabled = enableAds && !adsHasValidPackage;
    const templateId = M.fromMaybe(templateIdM, "");
    switch (templateId) {
        case ExploreTemplateId.BASIC:
        case ExploreTemplateId.VIEW_ALL:
        case ExploreTemplateId.DESCRIPTIVE:
            return (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
                React.createElement(ExploreDetailView, { anonymous: isAnonymous, read: environment, exploreDetails: exploreDetails, exploreTitle: exploreTitle, collectionId: M.fromMaybe(collectionIdM, ""), pageSize: itemsTotalPages, length: length, ageConstraint: minimumAge, bannerId: bannerId, isAdsEnabled: isAdsEnabled, showTitle: title, premiumPackages: premiumPackages, railType: templateId === ExploreTemplateId.DESCRIPTIVE
                        ? RailTypes.Descriptive
                        : RailTypes.Basic, mandatoryParams: mandatoryParams })));
        default:
            return React.createElement(React.Fragment, null);
    }
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, Explore);

